import { render } from "./PromotionList.vue?vue&type=template&id=3955a1a6&ts=true"
import script from "./PromotionList.vue?vue&type=script&lang=ts"
export * from "./PromotionList.vue?vue&type=script&lang=ts"

import "./PromotionList.vue?vue&type=style&index=0&id=3955a1a6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__